import PropTypes from "prop-types";
import React from "react";

import { useFeature } from "shared/utils/hooks/useFeature";
import { Container, Flag } from "./styles";

const Flags = ({ flags, isStatic }) => {
  const isTagsEnabled = useFeature("f_tags");
  const wrappers = {
    top_left: [],
    top_right: [],
    bottom_left: [],
    bottom_right: [],
  };

  for (let i = 0; i < flags?.length; i++) {
    const flag = flags[i];

    if (flag.active) {
      wrappers[flag.flag_position].push(flag);
    }
  }

  if (!isTagsEnabled) return <></>;

  return (
    <Container className={isStatic && "static-flag"}>
      {Object.keys(wrappers).map((wrapper) => {
        if (!wrappers[wrapper]?.length) return null;

        return (
          <div key={wrapper} className={`flags-wrapper ${wrapper}`}>
            {wrappers[wrapper].map((flag) => {
              switch (flag.type) {
                case "text":
                  return (
                    <Flag
                      key={flag.id}
                      textColor={flag.content?.text_color}
                      backgroundColor={flag.content?.background_color}
                    >
                      <span>{flag.content?.text}</span>
                    </Flag>
                  );

                case "image":
                  return <Flag key={flag.id} image={flag.content?.image} />;

                default:
                  return null;
              }
            })}
          </div>
        );
      })}
    </Container>
  );
};

Flags.defaultProps = {
  flags: [],
  isStatic: false,
};

Flags.propTypes = {
  flags: PropTypes.array,
  isStatic: PropTypes.bool,
};

export default React.memo(Flags);
